/*
 * Generated from bjornlunden.se.Typing.TypeScriptDefinitionQueue
 */

export interface SendPayload {
    Attendees: Attendee[];
    SelectedEventIds: string[];
}

export interface Attendee {
    Name: string;
    Comment: string;
    Company: string;
    Email: string;
}

export interface SendResponse {
    success: boolean;
    message: string;
}

export interface CheckResponse {
    Ok: boolean;
    Message: string;
    Events: CheckResponseEvent[];
}

export interface CheckResponseEvent {
    EventId: string;
    Ok: boolean;
    Message: string;
}

export interface SearchParams extends PaginationParams, IPaginationParams {
    SearchText: string;
}

export interface IPaginationParams {
    CurrentPage: number;
    ItemsPerPage: number;
}

export interface PaginationParams extends IPaginationParams {
    CurrentPage: number;
    ItemsPerPage: number;
}

export interface SearchResult {
    Groups: SearchGroup[];
}

export interface SearchGroup {
    Category: SearchCategory;
    Result: ISearchResultItem[];
}

export enum SearchCategory {
    Product = 1,
    Page = 2,
    Event = 4
}

export interface ISearchResultItem {
}

export interface SearchResultPage extends ISearchResultItem {
    Id: number;
    Title: string;
    Desc: string;
    PageLink: string;
    IsEvent: boolean;
}

export interface SearchResultArticle extends ISearchResultItem {
    ArticleNr: string;
    Title: string;
    Isbn: string;
    PageLink: string;
    ImageUrl: string;
    Desc: string;
}

export interface GetSubjectsParams {
    CurrentPageId: number;
    TagType: TagHolderTypes;
}

export enum TagHolderTypes {
    All = 0,
    BusinessKnowledge = 1,
    Templates = 2,
    Books = 3,
    Courses = 4,
    Programs = 5,
    IntegrationCategories = 6,
    IntegrationPrograms = 7,
    CourseType = 8,
    BusinessBlog = 9,
    BureauBlog = 10,
    BlTax = 11,
    BlClosure = 12,
    BlBureauSupport = 13,
    BlAdministration = 14
}

export interface GetTemplatesParams extends PaginationParams, IPaginationParams {
    CurrentPageId: number;
    TagType: TagHolderTypes;
}

export interface UpdateRelationParams extends GetPackagesInputParams {
    PackageToUpdate: number;
}

export interface GetPackagesInputParams {
    CurrentPageId: number;
    TagType: TagHolderTypes;
}

export interface Package {
    PageId: number;
    Title: string;
    IsInPackage: boolean;
}

export interface TemplateData {
    Title: string;
    Description: string;
    ImageUrl: string;
    PageId: number;
    Link: string;
    Price: string;
    ArticleNr: string;
}

export interface ArticlesData {
    Pagination: PaginationData;
    Articles: Article[];
    TopArticles: Article[];
}

export interface PaginationData {
    LastPage: number;
    Pages: number[];
}

export interface Article extends SimplePage {
    IsWord: boolean;
    Title: string;
    Description: string;
    PublishDate: Date;
    ImageUrl: string;
    PageId: number;
    Published: string;
    ArticleLink: string;
    ReadMoreAnchor: string;
    MainArticle: boolean;
}

export interface SimplePage {
    IsWord: boolean;
    Title: string;
    Description: string;
    PublishDate: Date;
    ImageUrl: string;
    PageId: number;
    Published: string;
    ArticleLink: string;
    ReadMoreAnchor: string;
    MainArticle: boolean;
}

export interface LatestArticleParams {
    ItemsToTake: number;
    CurrentPage: number;
    MainArticleIds: string;
    SubjectId?: number;
    FetchChildren: boolean;
    CurrentPageId: number;
    ShouldHideMainArticles: boolean;
    ChildrenOf: number;
    AllowedTagIds: string;
}

export interface Payload {
    FormView: boolean;
    Locations: EventLocation[];
    EventData: EventTimeResult[];
    EnrolledText: string;
    EventLocationPopupText: string;
}

export interface EventLocation {
    PageId: number;
    Title: string;
    Link: string;
}

export interface EventTimeResult {
    TimeString: string;
    Events: EventTime[];
}

export interface EventTime {
    ParentPageId: number;
    EventId: string;
    IsMaxedOut: boolean;
    AllowQueue: boolean;
    Title: string;
    Ingress: string;
    Desc: string;
    TimeStart: Date;
    TimeEnd: Date;
    Color: string;
    CourseMatrixColorTitle: string;
    Category: string;
    AllDayBreak: boolean;
    LocationNames: string[];
    TimeString: string;
}

export interface PaginationData {
    LastPage: number;
    Pages: number[];
}

export interface Subject {
    PageId: number;
    Title: string;
    Checked: boolean;
    IsMain: boolean;
}

